export default "__VITE_ASSET__a1wOo$4r__"